<template>
    <div class="xScrollable">
        <table class="kgr-table kgr-table--block kgr-table--striped data-table table-groups printable">
            <thead>
                <tr class="kgr-table__row">
                    <td class="kgr-table__cell">
                        <input
                            type="checkbox"
                            @change="$emit('selectAll')"
                        />
                    </td>
                    <td
                        class="kgr-table__cell"
                        :colspan="colspan"
                    >
                        <div class="kgr-accordion__itemHeadline">
                            &nbsp;{{ headline }}
                            <kgr-icon
                                class="kgr-icon kgr-icon--tiny openConfig"
                                icon-class="settings"
                                :title="tOpenTableConfig"
                                @click="openTableConfigurationDialog()"
                            />
                        </div>
                        <div class="kgr-postfix__fixed">
                            <kgr-checkbox
                                v-if="hasDeletedWaitListEntries"
                                class="kgr-checkbox--inline inline-checkbox"
                                :checked="showDeletedWaitListEntries"
                                :label="$t('Historie anzeigen')"
                                @change="switchShowDeletedWaitListEntries()"
                            />
                        </div>
                    </td>
                </tr>
                <tr class="kgr-table__row">
                    <th class="kgr-table__cell kgr-table__cell--headline"></th>
                    <th
                        v-show="showColumn(TableColumn.NAME)"
                        class="kgr-table__cell kgr-table__cell--headline"
                        colspan="2"
                    >
                        {{ tBookingName }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingContractStatus }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.AGE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingAge }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.EMAIL)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingEmail }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.PHONE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingPhone }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.PHONE_MOBILE)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingPhoneMobile }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tEmergencyContact }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.BOOKED_AT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingBookedAt }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.INFORMED_AT)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingInformedAt }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.ATTENDEE_STATUS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingAttendeeStatus }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.STATUS_WAITLIST)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingStatus }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.CONTRACT_END)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingContractEnd }}
                    </th>
                    <th
                        v-show="showColumn(TableColumn.DEPARTMENTS)"
                        class="kgr-table__cell kgr-table__cell--headline"
                    >
                        {{ tBookingDepartments }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-if="pending"
                >
                    <td :colspan="colspan">
                        <kgr-loading />
                    </td>
                </tr>
                <tr
                    v-for="waitListEntry in filteredWaitList"
                    :key="waitListEntry.id"
                    class="kgr-table__row"
                    :class="{'is-inactive': waitListEntry.deletedAt}"
                >
                    <td class="kgr-table__cell">
                        <input
                            :id="waitListEntry.member.email"
                            v-model="waitListEntry.checked"
                            type="checkbox"
                            :value="waitListEntry.member.email"
                            :disabled="waitListEntry.deletedAt !== null"
                            @change="$emit('checkWaitList', {id: waitListEntry.id, checked: waitListEntry.checked})"
                        />
                    </td>
                    <td
                        class="kgr-table__cell"
                        style="width: 20px;"
                    >
                        <div style="display: inline-block;">
                            <div style="line-height: 0">
                                <kgr-icon
                                    v-if="waitListEntry.canEdit"
                                    icon-class="arrow-up"
                                    :small="true"
                                    class="kgr-actionButton__icon"
                                    style="display: inline-block; width: 16px; height: 16px; line-height: 0;"
                                    :disabled="waitListEntry.deletedAt !== null"
                                    @click="prioUp(waitListEntry)"
                                />
                            </div>
                            <div style="text-align: center;">
                                <div v-if="waitListEntry.priority !== null">
                                    {{ waitListEntry.priority }}
                                </div>
                                <div v-else>
                                    <div style="line-height: 0">
                                        <kgr-delete-dialog
                                            v-if="waitListEntry.status === 'created' && waitListEntry.canEdit"
                                            :value="confirmDeleteId === waitListEntry.id"
                                            :object-name="waitListEntry.member.fullName()"
                                            @post-input="onDeleteDialogInput"
                                            @confirm="deleteWaitListEntry(waitListEntry)"
                                        >
                                            <kgr-icon
                                                icon-class="delete"
                                                :small="true"
                                                class="kgr-actionButton__icon"
                                                style="display: inline-block; width: 16px; height: 16px; line-height: 0;"
                                                :disabled="waitListEntry.deletedAt !== null"
                                                @click="showDeleteDialog(waitListEntry)"
                                            />
                                        </kgr-delete-dialog>
                                        <div v-else>
                                            {{ ' - ' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="line-height: 0">
                                <kgr-icon
                                    v-if="waitListEntry.canEdit"
                                    icon-class="arrow-down"
                                    :small="true"
                                    class="kgr-actionButton__icon"
                                    style="display: inline-block; width: 16px; height: 16px; line-height: 0;"
                                    :disabled="waitListEntry.deletedAt !== null"
                                    @click="prioDown(waitListEntry)"
                                />
                            </div>
                        </div>
                    </td>
                    <td v-show="showColumn(TableColumn.NAME)">
                        <a
                            v-if="waitListEntry.canViewShortProfile"
                            :href="memberLink(waitListEntry.member.id)"
                            target="_blank"
                            class="kgr-link"
                        >
                            {{ waitListEntry.member.fullName() }}
                        </a>
                        <template v-else>
                            {{ waitListEntry.member.fullName() }}
                        </template>
                    </td>
                    <td
                        v-show="showColumn(TableColumn.CONTRACT_STATUS)"
                        class="kgr-table__cell kgr-table__cell--noGrow"
                        :data-order="waitListEntry.member.contractState.status"
                    >
                        <kgr-member-contract-state-icon :state="waitListEntry.member.contractState" />
                    </td>
                    <td
                        v-show="showColumn(TableColumn.AGE)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.member.age }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.EMAIL)"
                        class="kgr-table__cell"
                    >
                        <a
                            v-if="waitListEntry.member.email"
                            :href="'mailto:' + waitListEntry.member.email"
                            @click="$emit('copyMailAddress', waitListEntry.member.email)"
                            :title="waitListEntry.member.email"
                        >
                            <kgr-icon
                                class="kgr-icon kgr-icon--small"
                                icon-class="email"
                            />
                        </a>
                    </td>
                    <td
                        v-show="showColumn(TableColumn.PHONE)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.member.phone }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.PHONE_MOBILE)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.member.phoneMobile }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.EMERGENCY_CONTACT)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.member.emergencyContact }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.BOOKED_AT)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.createdAt }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.INFORMED_AT)"
                        class="kgr-table__cell"
                    >
                        {{ waitListEntry.notificationsSentAt }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.ATTENDEE_STATUS)"
                        class="kgr-table__cell"
                    >
                        {{ $t('attendanceList.member.status.' + waitListEntry.attendeeStatus) }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.STATUS_WAITLIST)"
                        class="kgr-table__cell"
                    >
                        {{ $t('waitListEntry.status.' + waitListEntry.status) }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.CONTRACT_END)"
                        class="kgr-table__cell"
                    >
                        {{ formatContractEnd(waitListEntry.member.contractEnd) }}
                    </td>
                    <td
                        v-show="showColumn(TableColumn.DEPARTMENTS)"
                        class="kgr-table__cell"
                    >
                        {{ parseMemberDepartments(waitListEntry.member) }}
                    </td>
                </tr>
            </tbody>
        </table>
        <br />
        <kgr-table-configuration
            ref="tableConfiguration"
            :offering="offering"
            :table-columns="tableColumns"
            :user-id="userId"
            :show-dialog="showTableColumnConfig"
            :type="TableColumn.TABLE_TYPE_WAITLIST"
            @change="updateColumns"
            @closeDialog="closeTableConfigurationDialog()"
        />
    </div>
</template>

<script>
import Checkbox from '../../common/form/checkbox/Checkbox.vue';
import DeleteDialog from '../../common/modal/DeleteDialog.vue';
import Icon from '../../common/icon/Icon.vue';
import KgrMemberContractStateIcon from '../../members/MemberContractStateIcon.vue';
import Loading from '../../common/Loading.vue';
import Offering from '../../../js/dto/offering/Offering.js';
import TableColumn from '../../../js/dto/offering/TableColumn.js';
import TableConfiguration from './TableConfiguration.vue';
import WaitListRepository from '../../../js/repository/WaitListRepository.js';
import moment from 'moment';

export default {
    name: 'KgrGenericAppointmentWaitListTable',
    components: {
        'kgr-checkbox': Checkbox,
        'kgr-delete-dialog': DeleteDialog,
        'kgr-icon': Icon,
        'kgr-loading': Loading,
        'kgr-member-contract-state-icon': KgrMemberContractStateIcon,
        'kgr-table-configuration': TableConfiguration,
    },
    props: {
        offering: {
            type: Offering,
            required: true,
        },
        waitList: {
            type: Array,
            required: true,
        },
        headline: {
            type: String,
            required: true,
        },
        canAccept: {
            type: Boolean,
            required: false,
            default: false
        },
        canReject: {
            type: Boolean,
            required: false,
        },
        pending: {
            type: Boolean,
            required: false,
            default: false
        },
        userId: {
            type: Number,
            required: true,
        },
        tableColumns: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            confirmDeleteId: null,
            showDeletedWaitListEntries: false,
            showTableColumnConfig: false,
            selectedColumns: null,
        }
    },
    computed: {
        TableColumn () {
            return TableColumn;
        },
        colspan() {
            if (!this.selectedColumns) {
                return 14;
            }
            return this.selectedColumns.length + 1;
        },
        tOpenTableConfig() {
            return this.$t('offering.tableConfig');
        },
        tBookingName() {
            return this.$t('Name');
        },
        tBookingContractStatus() {
            return this.$t('booking.contractStatus');
        },
        tBookingAge() {
            return this.$t('booking.age');
        },
        tBookingEmail() {
            return this.$t('booking.email');
        },
        tBookingPhone() {
            return this.$t('booking.phone');
        },
        tBookingPhoneMobile() {
            return this.$t('booking.phoneMobile');
        },
        tEmergencyContact() {
            return this.$t('booking.emergencyContact');
        },
        tBookingBookedAt() {
            return this.$t('booking.bookedAt');
        },
        tBookingInformedAt() {
            return this.$t('booking.informedAt');
        },
        tBookingAttendeeStatus() {
            return this.$t('booking.attendeeStatus');
        },
        tBookingStatus() {
            return this.$t('Status');
        },
        tBookingContractEnd() {
            return this.$t('booking.contractEnd');
        },
        tBookingDepartments() {
            return this.$t('Abteilungen');
        },
        hasDeletedWaitListEntries() {
            return this.waitList.filter(entry => entry.deletedAt).length;
        },
        filteredWaitList() {
            if (this.showDeletedWaitListEntries) {
                return this.waitList;
            }

            return this.waitList.filter(entry => !entry.deletedAt);
        },
    },
    methods: {
        memberLink(memberId) {
            return `/backend/clubs/members/${memberId}/show`;
        },
        switchShowDeletedWaitListEntries() {
            this.showDeletedWaitListEntries = !this.showDeletedWaitListEntries;
        },
        prioUp(waitListEntry) {
            WaitListRepository.prioritizeUp(waitListEntry)
                .then(() => this.$emit('updateWaitList'))
                .catch(() => this.$notify.error('error.loadingData'));
        },
        prioDown(waitListEntry) {
            WaitListRepository.prioritizeDown(waitListEntry)
                .then(() => this.$emit('updateWaitList'))
                .catch(() => this.$notify.error('error.loadingData'));
        },
        deleteWaitListEntry(waitListEntry) {
            WaitListRepository.delete(waitListEntry)
                .then(() => {
                    this.showDeletedWaitListEntries = true;
                    this.$emit('updateWaitList');
                })
                .catch(() => this.$notify.error('error.loadingData'));
        },
        onDeleteDialogInput() {
            this.confirmDeleteId = null;
        },
        showDeleteDialog(waitListEntry) {
            this.confirmDeleteId = waitListEntry.id;
        },
        openTableConfigurationDialog() {
            this.showTableColumnConfig = true;
        },
        closeTableConfigurationDialog() {
            this.showTableColumnConfig = false;
        },
        updateColumns() {
            this.selectedColumns = this.$refs.tableConfiguration.loadConfiguration();
        },
        showColumn(column) {
            if (!this.selectedColumns) {
                return true;
            }
            return this.selectedColumns.includes(column);
        },
        getSelectedColumns() {
            return this.selectedColumns;
        },
        formatContractEnd(contractEnd) {
            return contractEnd ? moment(contractEnd, 'YYYY-MM-DD').format('DD.MM.YYYY') : '';
        },
        parseMemberDepartments(member) {
            return member.departments ? member.departments.join(', ') : '';
        },
    },
    mounted() {
        this.updateColumns()
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.openConfig {
    float: right;
    margin-right: 20px;
}
.xScrollable {
    overflow-x: auto;
}
</style>
